/* eslint-disable jest/require-hook */

import {
  matchCardWidget,
  matchChangeHpWidget,
  dataCardFootballRankingWidget,
  dataCardFootballCalendarWidget,
} from '@sky-it-livedata/livedata-data-cards-widgets';
import { defineWebComponents } from '@sky-it-livedata-libraries/livedata-commons-client';

/* Import Dynamic Components */
import DynamicDataCardFootballRanking from './components/data-card-football-ranking/dynamic-data-card-football-ranking';
import DynamicMatchCardDetail from './components/match-card/dynamic-match-card';
import DynamicMatchChangeHp from './components/match-change-hp/dynamic-match-change-hp';
import DynamicDataCardFootballCalendar from './components/data-card-football-calendar/dynamic-data-card-football-calendar';
import { setImgPlaceholder } from './utils/image-placeholder';
import manageImagePlaceholders from './utils/placeholder-images';

const webComponentsMap = new Map();
webComponentsMap.set(matchCardWidget.tag, DynamicMatchCardDetail);
webComponentsMap.set(matchChangeHpWidget.tag, DynamicMatchChangeHp);
webComponentsMap.set(dataCardFootballCalendarWidget.tag, DynamicDataCardFootballCalendar);
webComponentsMap.set(dataCardFootballRankingWidget.tag, DynamicDataCardFootballRanking);
console.info('defineWebComponents', { webComponentsMap }); // eslint-disable-line no-console

defineWebComponents(webComponentsMap);

manageImagePlaceholders();

document.addEventListener('DOMContentLoaded', () => {
  setImgPlaceholder();
});
